<template>
  <div class="ic-tool">
    <!-- Upload -->
    <div class="editor-pane" v-if="!done">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.ImageCompress.title') }}</span>
        <span class="pane-hint">PNG / JPEG / WebP · 50MB</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1"
        accept="image/png,image/jpeg,image/webp" :file-list="fileList">
        <i class="el-icon-picture-outline" style="font-size:42px;color:#c0c4cc" />
        <div class="el-upload__text">{{ $t("tool.ImageBgRemove.dropText") }}<em>{{ $t("tool.ImageBgRemove.clickUpload") }}</em></div>
      </el-upload>
      <div v-if="file" class="ic-info">
        <span>{{ $t('tool.ImageCompress.original') }}：<b>{{ fmtSize(origSize) }}</b></span>
        <span>{{ origW }} × {{ origH }}</span>
        <span>{{ origType }}</span>
      </div>
      <div v-if="file" class="ic-config">
        <span class="ic-ctrl-lbl">质量 {{ quality }}%</span>
        <el-slider v-model="quality" :min="10" :max="100" style="width:180px" />
        <el-button type="primary" size="small" @click="compress">{{ $t("common.action.compress") }}</el-button>
      </div>
    </div>

    <!-- Result -->
    <div class="ic-result" v-if="done">
      <div class="ic-result-hd">
        <span class="pane-dot output-dot" />
        <span class="pane-label">{{ $t('tool.ImageCompress.title') }}</span>
      </div>
      <div class="ic-compare">
        <div class="ic-compare-item">
          <p>{{ $t('tool.ImageCompress.original') }}（{{ fmtSize(origSize) }}）</p>
          <img :src="origUrl" />
        </div>
        <div class="ic-compare-item">
          <p>{{ $t('tool.ImageCompress.compressed') }}（{{ fmtSize(newSize) }}）</p>
          <img :src="newUrl" />
        </div>
      </div>
      <div class="ic-stats">
        减小 <strong>{{ pct }}%</strong>，{{ fmtSize(origSize) }} → {{ fmtSize(newSize) }}
      </div>
      <div class="ic-result-actions">
        <el-button size="small" type="primary" icon="el-icon-download" @click="download">{{ $t("common.action.download") }}</el-button>
        <el-button size="small" plain @click="reset">重新压缩</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ImageCompressTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],quality:80,origUrl:'',origSize:0,origW:0,origH:0,origType:'',newUrl:'',newSize:0,done:false}),
  computed:{ pct(){ return this.origSize ? Math.round((1-this.newSize/this.origSize)*100) : 0 } },
  methods:{
    fmtSize(s){ return s<1024?s+'B':s<1048576?(s/1024).toFixed(1)+'KB':(s/1048576).toFixed(2)+'MB' },
    handleFile(f){if(f.size>50*1024*1024){this.$message.error('最大50M');return}this.file=f.raw;this.fileList=[f];this.origSize=f.size;this.origType=f.raw.type;const r=new FileReader();r.onload=e=>{this.origUrl=e.target.result;const img=new Image();img.onload=()=>{this.origW=img.width;this.origH=img.height};img.src=this.origUrl};r.readAsDataURL(f.raw)},
    compress(){if(!this.file)return;const img=new Image();img.onload=()=>{const c=document.createElement('canvas');c.width=img.width;c.height=img.height;const ctx=c.getContext('2d');ctx.drawImage(img,0,0);c.toBlob(b=>{this.newSize=b.size;const r=new FileReader();r.onload=e=>{this.newUrl=e.target.result;this.done=true};r.readAsDataURL(b)},'image/jpeg',this.quality/100)};img.src=this.origUrl},
    download(){const a=document.createElement('a');document.body.appendChild(a);a.href=this.newUrl;a.download='compressed.jpg';a.click();document.body.removeChild(a)},
    reset(){this.file=null;this.fileList=[];this.done=false;this.origUrl='';this.newUrl=''},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.ic-tool { display:flex;flex-direction:column;gap:16px; }

.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.ic-tool ::v-deep .el-upload { width:100%; }
.ic-tool ::v-deep .el-upload-dragger { display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; max-width:100%; width:100%; box-sizing:border-box; }

.ic-info { display:flex;align-items:center;gap:14px;margin-top:12px;font-size:12px;color:#909399; }
.ic-info b { color:#303133; }

.ic-config { display:flex;align-items:center;gap:12px;margin-top:12px;flex-wrap:wrap; }
.ic-ctrl-lbl { font-size:12px;color:#909399;white-space:nowrap; }

.ic-result { background:#f0f9eb;border:1px solid #e1f3d8;border-radius:12px;padding:20px 24px; }
.ic-result-hd { display:flex;align-items:center;gap:8px;margin-bottom:16px; }
.ic-result-actions { display:flex;gap:8px;margin-top:16px; }
.ic-compare { display:flex;gap:20px; }
.ic-compare-item { flex:1;text-align:center; }
.ic-compare-item p { font-size:12px;color:#909399;margin-bottom:8px;font-weight:600; }
.ic-compare-item img { max-width:100%;max-height:320px;border:1px solid #e4e7ed;border-radius:8px;background:#fff; }
.ic-stats { text-align:center;margin-top:12px;font-size:14px;color:#67c23a; }
.ic-stats strong { font-size:20px; }

@media (max-width: 640px) {
  .editor-pane { padding:12px 14px; }
  .pane-hint { display:none; }
  .ic-tool ::v-deep .el-upload-dragger { min-height:140px;padding:20px 12px; }
  .ic-tool ::v-deep .el-upload__text { font-size:12px; }
  .ic-compare { flex-direction:column; }
  .ic-result { padding:14px 16px; }
}
</style>
